module.exports = __webpack_public_path__ + "img/ecart-seller.1f6e2e27.svg";